import { render, staticRenderFns } from "./SuspendedEmployees.vue?vue&type=template&id=7b2dc573&scoped=true"
import script from "./SuspendedEmployees.vue?vue&type=script&lang=js"
export * from "./SuspendedEmployees.vue?vue&type=script&lang=js"
import style0 from "./SuspendedEmployees.vue?vue&type=style&index=0&id=7b2dc573&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b2dc573",
  null
  
)

export default component.exports